import { memo } from 'react'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { GenerateAiSummaryStatus } from 'builder/modules/constants'
import ModalOverlay from 'builder/components/ModalOverlay'
import ProcessAnimation from './ProcessAnimation'
import GenerationFailed from './GenerationFailed'
import { Props } from './types'

export const AiAssistantProcessing = memo((props: Props) => {
  const { status } = props
  const { isPhone } = useMediaQueries()
  if (status !== GenerateAiSummaryStatus.failed && status !== GenerateAiSummaryStatus.processing) {
    return null
  }
  return (
    <ModalOverlay overlayFadeDuration={300} contentSlideDuration={300} fullScreen={isPhone}>
      {status === GenerateAiSummaryStatus.failed && <GenerationFailed {...props} />}
      {status === GenerateAiSummaryStatus.processing && <ProcessAnimation />}
    </ModalOverlay>
  )
})
